import { z } from 'zod';

const dataVersionOptions = [
  'PCM_NA_14Q2',
  'PCM_NA_13Q2',
  'PCM_NA',
  'PCM_SE',
  'PCM_ME',
  'PCM_AS',
  'PCM_AF',
  'PCM_GT',
  'PCM_SA',
  'PCM_OC',
  'PCM_EU',
  'Current',
] as const;

export const dataVersionSchema = z.enum(dataVersionOptions);

export type DataVersion = z.infer<typeof dataVersionSchema>;
